import axios from "axios";
import API_VERSION from "../data/api-version";

const GetCharacters = async () => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
           metaobjects(type: "character", first: 100) {
            nodes {
              fields {
                value
                key
              }
            }
          }
        }`,
      },
    });

    const { nodes } = response?.data?.data?.metaobjects;

    if (nodes) {
      return nodes.map((item) => {
        const fields = {};
        item.fields.forEach((field) => {
          fields[field.key] = field.value?.trim();
        });
        return fields;
      });
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetCharacters;
